// extracted by mini-css-extract-plugin
export default {"masjidSearchDiv":"masjidSearch_masjidSearchDiv__fJJzL","searchContainer":"masjidSearch_searchContainer__bKQJz"};